export default __webpack_public_path__ + "static/media/icon-person-warning-female-desktop.50f0074e.svg";